/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactResponseDto } from '../../models/sales-contact-response-dto';

export interface ContactsControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;
}

export function contactsControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: ContactsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContactResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesContactResponseDto>>;
    })
  );
}

contactsControllerFindAllByTenant.PATH = '/o2-sales/contacts/{tenant}';
